import HighlightedTable from 'components/HighlightedTable/HighlightedTable';
import './RoutingPlansUpdated.css';
import { capitaliseFirstChar, conditionTargetToLabel, getMessagePlanStatusColour } from 'utils/formattingUtils';
import { DateTime } from 'luxon';
import { VersionedRoutingPlan } from 'utils/routingPlansUtils';
import { Tag } from 'nhsuk-react-components';

interface RoutingPlansUpdatedProps {
  plans: VersionedRoutingPlan[];
}

function RoutingPlansUpdated({ plans }: RoutingPlansUpdatedProps) {
  return (
    <HighlightedTable>
      <HighlightedTable.HeaderRow style={{ fontSize: '18px' }}>
        <HighlightedTable.HeaderValue className="routing-plans-updated__header-old-or-new">
          Old / New
        </HighlightedTable.HeaderValue>
        <HighlightedTable.HeaderValue className="routing-plans-updated__header-routing-plan">
          Message plan
        </HighlightedTable.HeaderValue>
        <HighlightedTable.HeaderValue className="routing-plans-updated__header-last-updated">
          Last updated
        </HighlightedTable.HeaderValue>
        <HighlightedTable.HeaderValue className="routing-plans-updated__header-status">
          Status
        </HighlightedTable.HeaderValue>
      </HighlightedTable.HeaderRow>
      {plans.map((item) => {
        const createdAt = DateTime.fromMillis(Number(item.routingPlan.created_at));

        return (
          <HighlightedTable.Row key={`${item.routingPlan.routing_plan_id}${item.status}`} style={{ fontSize: '18px' }} className={item.routingPlan.status === 'draft' || item.status === 'outdated' ? 'routing-plans-updated__row--draft' : undefined}>
            <HighlightedTable.Value>
              {item.status === 'latest' ? 'New' : 'Old'}
            </HighlightedTable.Value>
            <HighlightedTable.Value>
              {item.routingPlan.routing_plan_name}
              {item.routingPlan.comms_target && (
              <div className="nhsuk-u-margin-top-2 nhsuk-u-secondary-text-colour">
                Target:
                {' '}
                {conditionTargetToLabel(item.routingPlan.comms_target)}
              </div>
              )}
            </HighlightedTable.Value>
            <HighlightedTable.Value>
              <>
                <div>{createdAt.toFormat('dd LLL yyyy')}</div>
                <div>{createdAt.toFormat('HH:mm')}</div>
              </>
            </HighlightedTable.Value>
            <HighlightedTable.Value>
              <Tag modifier={getMessagePlanStatusColour(item.routingPlan.status)}>{capitaliseFirstChar(item.routingPlan.status)}</Tag>
            </HighlightedTable.Value>
          </HighlightedTable.Row>
        );
      })}
    </HighlightedTable>
  );
}

export default RoutingPlansUpdated;
